export default class UserService {
    constructor(user) {
        this.user = user
    }

    isCustomer() {
        return this.user.isCustomer
    }

    isOverUsageLimit() {
        return Number(this.user.currentUsage) > 100
    }

    isOverWarningLimit() {
        return Number(this.user.currentUsage) > 90
    }
}